<template>
    <div v-if="result.costRating">
      <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
      <div class="cost-rating">
        <hp5-semantic size-selection="xs">
          <p>Costs of this provider’s care group are  {{ costRatingDescription }} </p>
        </hp5-semantic>
      </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        result: Object
    })

    const costRatingDescription = computed(() => {
      if (props.result.costRating.value === 4) {
        return 'higher than average';
      } else if (props.result.costRating.value >= 2 && props.result.costRating.value <= 3) {
        return 'average';
      } else if (props.result.costRating.value < 2) {
        return 'lower than average';
      }
      return '';
    });
</script>

<style lang="scss" scoped>
  .cost-rating {
    display: flex;
  }
  
  .rating {
    padding-top: 3px;
    padding-left: var(--spacing-xxs);
    padding-right: var(--spacing-xs);
  }
</style>